$(function () {
  'use strict';

  $.each($('.js-menu-applicable-number-label'), function() {
    var $this = $(this);
    var menu_id = $this.data('menu-id');

    if (menu_id) {
      $.ajax({url: '/api/v1/menus/' + menu_id + '/applicable_number' , type: 'get'}).done(function (response) {
        if (response["applicable"]) {
          $this.html(response["frequency_label"] + response["applicable_number_label"]);
        }
      });
    }
  });
});
